import { Offer as OfferModel } from "@comparaonline/offers-models";

export interface Offer extends OfferModel {
  ufPrice?: number;
}

export function getUF(offer: Offer): number {
  return offer.ufPrice || offer.product.mainAttribute.value.ufPrice;
}
